module.exports = __webpack_public_path__ + "static/media/MenuIcon.7d0d6f0a.svg";